import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { BASE_URL } from "../../redux/ApiEndPoints";
import Avatar from "../../assets/images/user.png";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function StudentDetailListForStudent() {
  const auth = useSelector((state) => state.auth);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEnrolledCourses = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${BASE_URL}student/enrolled-courses-progress`, {
          headers: {
            'Authorization': `Bearer ${auth.token}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data.success) {
            setCourses(data.data || []);
          }
        }
      } catch (error) {
        console.error('Error fetching enrolled courses:', error);
      } finally {
        setLoading(false);
      }
    };

    if (auth.token) {
      fetchEnrolledCourses();
    }
  }, [auth.token]);
  if (loading) {
    return (
      <article className="continue-learning-card card-default-style">
        <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
           <div className="dottedLoading theme-color"></div>
        </div>
      </article>
    );
  }

  if (courses.length === 0) {
    return (
      <article className="continue-learning-card card-default-style">
        <div className="d-flex justify-content-center align-items-center flex-column" style={{ height: '300px' }}>
          <h5 className="text-muted">No courses in progress</h5>
          <p className="text-muted small">Enroll in courses to see your progress here</p>
        </div>
      </article>
    );
  }

  return (
    <article className="continue-learning-card card-default-style h-100">
      <ul className="continue-learning-card-list list-unstyled">
        {courses.map((course, index) => {
          return (
            <li
              key={course?.courseId}
              className="continue-learning-card-list-item d-flex align-items-center process-style-for-array"
            >
              <div className="d-flex gap-2 flex-grow-1 align-items-center">
                <div className="img-holder">
                  <img 
                    src={course?.coursePicture || Avatar} 
                    alt={course?.courseName} 
                    className="img-fluid" 
                    style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '50%' }}
                    onError={(e) => {
                      e.target.src = Avatar;
                    }}
                  />
                </div>
                <div className="details">
                  <span className="ah-text-xs category mb-6 fw-semibold">
                    {course?.category}
                  </span>
                  <h4 className="mb-6 ah-text-base fw-semibold">
                    <Link to={`/student-courses-detail?id=${course?.courseId}`}>{course?.courseName}</Link>
                  </h4>
                  <p className="ah-text-xs lesson fw-semibold mb-0">
                     {course?.documentCount} Sources
                    {course?.isReady && (
                      <span className="badge bg-success ms-2">Ready for CertifyMe</span>
                    )}
                  </p>
                </div>
              </div>
              <div className="flex-shrink-0">
              <CircularProgressbar
                className="progress-circle-holder"
                value={course?.progress}
                strokeWidth={16}
                text={`${course?.progress}%`}
                styles={{
                  path: {
                    stroke: course?.progress === "100" ? "#F05202" : "#82BD00",
                  },
                  text: {
                    fill: "#000",
                    fontSize: "22px",
                  },
                  trail: {
                    stroke: course?.progress === "100" ? "#FAC8AE" : "#DBE9B9",
                  },
                }}
              />
              </div>
            </li>
          );
        })}
      </ul>
    </article>
  );
}
